var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"parallax",style:('background-image: url(' + _vm.image + ');'),attrs:{"fluid":""}})}
var staticRenderFns = []

export { render, staticRenderFns }